import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const grafana = defineConnector({
  identifier: "grafana",
  name: "Grafana",
  tagLine: "Observability and dashboards",
  keywords:
    "grafana cloud panels visualization metrics alerting monitoring datasources",
  logo,
  protocol: "http",
  tags: ["observability", "data"],
  defaultUrlPattern: () => "https://[^/]*\\.grafana\\.(net|com)/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Grafana API key or service account token",
      items: [
        {
          kind: "markdown",
          content:
            "In Grafana, go to **Administration > Service accounts** and create a new service account with a token. Alternatively, use **Configuration > API keys** for legacy API keys.",
        },
      ],
    },
    {
      title: "Enter your Grafana details",
      items: [
        {
          kind: "url",
          label: "Grafana instance URL",
          required: true,
          placeholder: "https://your-org.grafana.net",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Grafana instance.",
        },
        {
          kind: "input",
          label: "API key or service account token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/org`,
  },
  publicEnvVars: ({ instanceUrl }) => ({
    GRAFANA_URL: instanceUrl || "",
  }),
});
